define('views/modules/calendar/nutrition/food/list/food-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    // collections
    'collections/calendar/nutrition/foods',
    // views
    'views/parts/list/fetch-list',
    'views/modules/calendar/nutrition/food/list/food-list-item',
    // 'views/modules/calendar/nutrition/food/favorite/food-favorite-item',
    // templates
    'text!templates/modules/calendar/nutrition/food/list/food-list.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    // collections
    CFoods,
    // views
    VFetchList,
    VFoodListItem,
    // VFoodFavoriteItem,
    // templates
    TFoodList
) {

    var VFoodList = VFetchList.extend({
        item: VFoodListItem,
        template: TFoodList,
        className: "food-list-item-short",
        regions: {
            list: '.food-list'
        },
        sortable: {
            group: {
                name: 'food-item',
                pull: 'clone',
                put: false
            },
            sort: false,
            item: '.food-list-item',
            delay: Viewport.width() <= 768 ? 50 : 0,
            // handle: '.food-name',
            filter: '.food-item-right',
            onClone: 'onDragClone',
        },

        initialize: function(options) {
            this.options = options = options || {};
            var collection = this.collection;
            if (!collection) collection = this.collection = new CFoods(null, { full: true });
            this.favorite = options.favorite;

            VFoodList.__super__.initialize.apply(this, arguments);
        },

        getItemOptions: function(options) {
            return _.extend(options, {
                favorite: this.favorite,
                defaultServing: this.options.defaultServing
            });
        },

        addFood: function(models) {
            this.collection.add(models);
        },

        reset: function(options) {
            this.collection.reset(null, options);
        },

        unselect: function() {
            this.$('.food-list-item.active').removeClass('active');
        },

        _toggleHidden: function() {
            this.$el.toggleClass('hidden', this.collection.isEmpty());
        },

        resetList: function() {
            this._toggleHidden();
            VFoodList.__super__.resetList.apply(this, arguments);
        },

        /////////////////
        // drag events //
        /////////////////
        onDragClone: function(e) {
            this.$(e.clone).trigger('item:clone', [e.clone]);
        },

        ////////////
        // events //
        ////////////
        onUpdate: function() {
            this._toggleHidden();
            VFoodList.__super__.onUpdate.apply(this, arguments);
        },

        onAfterListRender: function() {
            var sortable = this.sortableElem;
            if (Viewport.isMobile() && sortable.el) {
                sortable.destroy();
            }
        },

    });

    return VFoodList;
});

